module.exports = __webpack_public_path__ + "static/espacios-8138a2d0758f26abca68b33a0e430030.jpg";